import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import GroupOrientation from './GroupOrientation';
import ClientProvider from './client';
export default createDemo(import.meta.url, GroupOrientation, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/button-group/demos/group-orientation/GroupOrientation.tsx",
    "fileName": "GroupOrientation.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Button from '@mui/material/Button';\nimport ButtonGroup from '@mui/material/ButtonGroup';\nimport Box from '@mui/material/Box';\n\nconst buttons = [\n  <Button key=\"one\">One</Button>,\n  <Button key=\"two\">Two</Button>,\n  <Button key=\"three\">Three</Button>,\n];\n\nexport default function GroupOrientation() {\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        '& > *': {\n          m: 1,\n        },\n      }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ButtonGroup orientation=\"vertical\" aria-label=\"Vertical button group\">\n        {buttons}\n      </ButtonGroup>\n      <ButtonGroup\n        orientation=\"vertical\"\n        aria-label=\"Vertical button group\"\n        variant=\"contained\"\n      >\n        {buttons}\n      </ButtonGroup>\n      <ButtonGroup\n        orientation=\"vertical\"\n        aria-label=\"Vertical button group\"\n        variant=\"text\"\n      >\n        {buttons}\n      </ButtonGroup>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 40,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Button from '@mui/material/Button';\nimport ButtonGroup from '@mui/material/ButtonGroup';\nimport Box from '@mui/material/Box';\n\nconst buttons = [\n  <Button key=\"one\">One</Button>,\n  <Button key=\"two\">Two</Button>,\n  <Button key=\"three\">Three</Button>,\n];\n\nexport default function GroupOrientation() {\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        '& > *': {\n          m: 1,\n        },\n      }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <ButtonGroup orientation=\"vertical\" aria-label=\"Vertical button group\">\n        {buttons}\n      </ButtonGroup>\n      <ButtonGroup\n        orientation=\"vertical\"\n        aria-label=\"Vertical button group\"\n        variant=\"contained\"\n      >\n        {buttons}\n      </ButtonGroup>\n      <ButtonGroup\n        orientation=\"vertical\"\n        aria-label=\"Vertical button group\"\n        variant=\"text\"\n      >\n        {buttons}\n      </ButtonGroup>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 40,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Button",
      "@mui/material/ButtonGroup",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
